<template>
  <div>
    <!-- LIST VIEW -->

    <v-list-item
      three-line
      v-if="!gridView"
      dense
      style="background: rgba(62, 39, 35, 0.5); border: 2px dashed rgba(255, 255, 255, 0.7);"
    >
      <v-list-item-avatar color="grey">
        <v-icon medium>subtitles</v-icon>
      </v-list-item-avatar>

      <v-list-item-content>
        <v-list-item-title class="subtitle-1">
          <span>
            {{ mediaTypeDescription }}
          </span>
        </v-list-item-title>
        <v-list-item-subtitle>
          {{ getLangName }}
        </v-list-item-subtitle>
      </v-list-item-content>

      <v-list-item-action>
        <div class="text-xs-right">
          <v-icon large @click="add()">add_circle_outline</v-icon>
        </div>
      </v-list-item-action>
    </v-list-item>

    <!-- GRID VIEW -->
    <v-card
      color="rgba(62, 39, 35, 0.5)"
      style="border: 2px dashed rgba(255, 255, 255, 0.7);"
      max-width="250"
      min-width="250"
      v-if="gridView"
    >
      <v-list-item>
        <v-list-item-avatar color="grey">
          <v-icon medium>subtitles</v-icon>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title class="subtitle-1">{{
            mediaTypeDescription
          }}</v-list-item-title>
          <v-list-item-subtitle class="text-truncate">
            {{ getLangName }}
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>

      <v-card-text style="max-height: 80px" class="pb-0 mb-4">
        {{ mediaTypeDescription }}
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-icon large @click="add()">add_circle_outline</v-icon>
        <!-- <v-btn icon v-on:click="edit()" title="Edit">
          <v-icon>edit</v-icon>
        </v-btn> -->
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import Enums from '@/helpers/Enums'
export default {
  components: {},
  props: {
    gridView: {
      type: Boolean,
      required: false,
      default: function() {
        return false
      }
    },
    langId: {
      type: Number,
      required: false,
      default: function() {
        return parseInt(
          this.$store.state.ProjectStore.projectConfig[
            this.$store.state.ProjectStore.projectConfig.length - 1
          ].mediaData.defaultLangId || 1
        )
      }
    }
  },

  created: function() {},
  computed: {
    getLangName() {
      return Enums.lang[this.langId].name
    }
  },
  methods: {
    add() {
      this.$emit('add', 'description')
    }
  },
  data: function() {
    return {
      name: '',
      bannerImageUrl: './assets/default_file_icon.png',
      descriptionText: '',
      mediaTypeDescription: 'Description',
      mediaDetailsDescription: 'Lang 1',
      mediaFileDescription: '',
      showDialog: false
    }
  }
}
</script>

<style scoped>
.ghost-wrapper {
  background: transparent !important;
  border: 2px dashed rgba(255, 255, 255, 0.7);
  box-sizing: border-box;
  border-radius: 6px;
  overflow: hidden;
}
.text-xs-right {
  white-space: nowrap;
}
</style>
